import React, { useEffect, useState } from "react";
import { TableRow, TableCell } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import moment from "moment";
import { NavLink, useParams } from "react-router-dom";

import { EventData } from "../../models/EventData";
import OddButton from "../OddButton/OddButton";
import inpaly from "../../assets/images/sports/inplay.svg";
import "./SportRadarEventsTable.scss";

type TableProps = {
  eventData: EventData;
};

export const SportRadarEventsTable: React.FC<TableProps> = (props) => {
  const { eventData } = props;

  const [winnerData, setWinnerData] = useState([
    { id: Math.random().toString(36).slice(2), name: "", isLocked: true },
    { id: Math.random().toString(36).slice(2), name: "", isLocked: true },
    { id: Math.random().toString(36).slice(2), name: "", isLocked: true },
  ]);
  const [hcpData, setHCPData] = useState([
    { id: Math.random().toString(36).slice(2), name: "", isLocked: true },
    { id: Math.random().toString(36).slice(2), name: "", isLocked: true },
  ]);
  const [totData, setTOTData] = useState([
    { id: Math.random().toString(36).slice(2), name: "", isLocked: true },
    { id: Math.random().toString(36).slice(2), name: "", isLocked: true },
  ]);

  const { provider } = useParams();
  const eventEnableStatus = ["in_play", "upcoming"];

  useEffect(() => {
    if (!eventData) {
      return;
    }
    if (
      !eventData?.markets?.matchOdds ||
      !eventData?.markets?.matchOdds[0]?.runners?.length
    ) {
      return;
    }

    let winData = [];
    let hCPData = [];
    let tOTData = [];

    eventData?.markets?.matchOdds.map((item) => {
      if (
        item.marketName === "1x2" ||
        item.marketName === "Winner" ||
        item.marketName.toLowerCase().startsWith("winner")
      ) {
        item.runners?.map((itm) => {
          winData.length < 3 &&
            winData.push({
              name: itm?.runnerName,
              id: itm?.runnerId,
              back: itm?.backPrices?.[0]?.price,
              lay: itm?.layPrices?.[0]?.price,
            });
          return true;
        });
      } else if (
        item.marketName === "Handicap"
        // && item.marketId.includes("0.5")
      ) {
        item.runners?.map((itm, index) => {
          hCPData.length < 2 &&
            hCPData.push({
              name: itm?.runnerName,
              id: itm?.runnerId,
              back: itm?.backPrices?.[0]?.price,
              lay: itm?.layPrices?.[0]?.price,
            });
          return true;
        });
      } else if (
        item.marketName === "Total"
        // && item.marketId.includes("3.25")
        // && item?.runners?.length === 2
      ) {
        item.runners?.map((itm, index) => {
          tOTData.length < 2 &&
            tOTData.push({
              name: itm?.runnerName,
              id: itm?.runnerId,
              back: itm?.backPrices?.[0]?.price,
              lay: itm?.layPrices?.[0]?.price,
            });
          return true;
        });
      }
      return true;
    });
    if (winData && winData.length) {
      if (winData?.length === 2) {
        winData.splice(1, 0, {
          id: Math.random().toString(36).slice(2),
          name: "",
          isLocked: true,
        });

        // winData.push({
        //   id: Math.random().toString(36).slice(2),
        //   name: "",
        //   isLocked: true,
        // });
      }
      setWinnerData(winData);
    }
    if (hCPData && hCPData.length) {
      if (hCPData?.length === 1) {
        hCPData.push({
          id: Math.random().toString(36).slice(2),
          name: "",
          isLocked: true,
        });
      }
      setHCPData(hCPData);
    }
    if (tOTData && tOTData.length) {
      if (tOTData?.length === 1) {
        tOTData.push({
          id: Math.random().toString(36).slice(2),
          name: "",
          isLocked: true,
        });
      }
      setTOTData(tOTData);
    }
  }, [eventData]);

  const getEventStatus = (value: string) => {
    if (eventEnableStatus.includes(value.toLocaleLowerCase())) {
      return true;
    }
    return false;
  };
  const handleSelectOdds = (data) => {
    console.log(data);
  };

  return (
    <>
      {eventData.eventId ? (
        <>
          <TableRow className="web-view">
            <TableCell
              align="center"
              className="date-col"
              component="th"
              scope="row"
            >
              <div className="date">
                {eventData.openDate &&
                  moment(eventData.openDate).format("MMM DD hh:mm A")}{" "}
              </div>
            </TableCell>

            <TableCell
              align="left"
              className="event-detail"
              component="th"
              scope="row"
              colSpan={2}
            >
              <NavLink
                to={`/lobby/${provider}/${eventData.sportId}/${eventData.eventId}/${eventData.competitionId}`}
                className="navlink"
              >
                <div className="event"> {eventData.eventName} </div>

                <div className="date">{eventData.competitionName}</div>
              </NavLink>
            </TableCell>

            <TableCell align="center">
              <div className="in-play-section">
                <div>
                  {eventData && eventData.status === "IN_PLAY" ? (
                    <img className="inplay-img" src={inpaly} alt="inpaly" />
                  ) : null}
                </div>

                <div
                  className={
                    eventData && eventData.status === "IN_PLAY"
                      ? "scorecard-section live"
                      : "scorecard-section"
                  }
                >
                  {eventData.homeScore ? eventData?.homeScore : 0} :&nbsp;
                  {eventData?.awayScore ? eventData?.awayScore : 0}
                </div>
              </div>
            </TableCell>

            <TableCell align="right">
              <OddButton
                data={winnerData}
                eventStatus={getEventStatus(eventData.status)}
                marketName="winner"
                onClick={(data) => {}}
              />
            </TableCell>

            <TableCell align="center">
              <OddButton
                data={hcpData}
                eventStatus={getEventStatus(eventData.status)}
                marketName="hcp"
                onClick={(data) => {}}
              />
            </TableCell>

            <TableCell align="left">
              <OddButton
                data={totData}
                eventStatus={getEventStatus(eventData.status)}
                marketName="tot"
                onClick={(data) => {}}
              />
            </TableCell>

            <TableCell align="center">
              <NavLink
                to={`/lobby/${provider}/${eventData.sportId}/${eventData.eventId}/${eventData.competitionId}`}
              >
                <ArrowForwardIosIcon className="all-markets-icon" />
              </NavLink>
            </TableCell>
          </TableRow>

          <TableRow className="mob-view">
            <TableCell align="left" className="mob-event-detail">
              <div className="mob-event-name">
                <NavLink
                  to={`/lobby/${provider}/${eventData.sportId}/${eventData.eventId}/${eventData.competitionId}`}
                  className="navlink"
                >
                  <div className="eventname"> {eventData.eventName} </div>

                  <div className="eventname">{eventData.competitionName}</div>
                </NavLink>
              </div>

              <div className="date-ctn">
                <div>
                  {eventData.openDate &&
                    moment(eventData.openDate).format("MMM DD hh:mm A")}{" "}
                </div>
                <div className="inplay-icon">
                  {eventData && eventData.status === "IN_PLAY" ? (
                    <img
                      className="inplay-img"
                      src={inpaly}
                      alt="inpaly"
                      height="15"
                      width="15"
                    />
                  ) : null}
                </div>
              </div>
              <div className="mob-odds-ctn-heading">
                <div className="market1">
                  <div className="naming">1</div>
                  <div className="naming">X</div>
                  <div className="naming">2</div>
                </div>
              </div>
              <div className="mob-odds-ctn">
                {" "}
                <OddButton
                  data={winnerData}
                  eventStatus={getEventStatus(eventData.status)}
                  marketName="winner"
                  onClick={(data) => {}}
                />
              </div>
            </TableCell>
          </TableRow>
        </>
      ) : null}
    </>
  );
};
